import type { RightPanelSlice, GeoDataStateCreator, RightPanelTabId } from './types';

/**
 * Slice dello store Zustand per la gestione dello stato del pannello destro.
 * Mantiene traccia della scheda attualmente attiva.
 */
export const createRightPanelSlice: GeoDataStateCreator<RightPanelSlice> = (set) => ({
  /**
   * L'ID della scheda attualmente attiva nel pannello destro.
   * Può essere 'style', 'data', 'general', o null se nessuna scheda è attiva o selezionata.
   */
  activeRightPanelTab: 'data', // Scheda 'Data Actions' attiva di default

  /**
   * Azione per impostare la scheda attiva nel pannello destro.
   * @param tabId L'ID della scheda da attivare (o null per nessuna).
   */
  setActiveRightPanelTab: (tabId: RightPanelTabId) => set(
    { activeRightPanelTab: tabId }
    // Rimuoviamo il terzo argomento, non necessario o supportato nella configurazione corrente
    // false, // Evita di sostituire l'intero stato - non necessario con partial state update
    // 'setActiveRightPanelTab' // Nome azione per DevTools - gestito automaticamente o non supportato qui
  ),
});